import React from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <footer>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-3 col-lg-6 col-xs-12">
              <div className="branch">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3542.152194020196!2d79.55014988758838!3d27.4021809779412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399e2f9384cff449%3A0x6ab75f9beb3a187!2sGayatri%20International%20School!5e0!3m2!1sen!2sin!4v1750936923264!5m2!1sen!2sin"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
                <div>
                  <h5>Branch 1</h5>
                  <p>
                    Opp. Mission Hospital, Chaurasi,
                    <br /> Farrukhabad Fatehgarh Road - 209625 (U.P.)
                  </p>
                  <p>
                    <i class="bi bi-telephone-fill"></i>{" "}
                    <a href="tel: 9519213001"> 9519213001</a> /{" "}
                    <a href="tel: 9519213002"> 9519213002</a>
                  </p>
                  {/*  <p><i class="bi bi-envelope-fill"></i> <a href="mailto: info@gayatriinternationalschool.com"> info@gayatriinternationalschool.com</a></p> */}
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-6 col-xs-12">
              <div className="branch">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3542.9376315784857!2d79.60067307618644!3d27.377663139953892!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399e31c3fe3abe39%3A0x3d825cf261337199!2sGayatri%20International%20school!5e0!3m2!1sen!2sin!4v1750936650211!5m2!1sen!2sin"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
                <div>
                  <h5>Branch 2</h5>
                  <p>
                    Near Gurgaon Devi Temple, <br /> Arrah Paharpur,
                    Farrukhabad-209625
                  </p>
                  <p>
                    <i class="bi bi-telephone-fill"></i>{" "}
                    <a href="tel:7398455906">7398455906</a> /{" "}
                    <a href="tel:7398455907">7398455907</a>
                  </p>
                  <p>
                    <i class="bi bi-envelope-fill"></i>{" "}
                    <a href="mailto: arrahpaharpur@gayatriinternationalschool.com">
                       arrahpaharpur@gayatriinternationalschool.com
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-2 col-lg-6 col-xs-12">
              <div className="qk_link">
                <h5>Quick links</h5>
                <ul>
                  <li>
                    <Link to="/SafetySecurity">
                      <i class="bi bi-caret-right-fill"></i> Safety and security
                    </Link>
                  </li>
                  <li>
                    <Link to="/Infrastructure">
                      <i class="bi bi-caret-right-fill"></i> Infrastructure
                    </Link>
                  </li>
                  <li>
                    <Link to="/LifeatGis">
                      <i class="bi bi-caret-right-fill"></i> Life of GIS
                    </Link>
                  </li>
                  <li>
                    <Link to="/ErpSoftware">
                      <i class="bi bi-caret-right-fill"></i> Erp Software
                    </Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="/Tc">
                      <i class="bi bi-caret-right-fill"></i> Transfer
                      Certificate
                    </Link>{" "}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-xs-12">
              <div className="mobile-app">
                <div>
                  <h5>Download Mobile App </h5>
                  <p>
                    {" "}
                    CampusCare 10x mobile app for parents is a tool that serves
                    as a single point of reference for parents. The app
                    centralises all the school-parent interaction and lets
                    parents stay updated with their ward's day-to-day
                    activities. Parents can receive assignments, homework, and
                    circulars, keep track of their child's attendance, do online
                    fee payment, view report cards.
                  </p>
                  <div className="mobile-link">
                    <Link
                      to="https://apps.apple.com/in/app/campuscare-10x/id1611283814"
                      target="_blank"
                    >
                      <LazyLoad>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/app-store.png"
                          alt="Gayatri International School"
                        />
                      </LazyLoad>
                    </Link>
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.entab.learninglab&hl=en-IN"
                      target="_blank"
                    >
                      <LazyLoad>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/playstore.png"
                          alt="Gayatri International School"
                        />
                      </LazyLoad>
                    </Link>
                  </div>
                  <p className="code"> School Code : GISFUP</p>
                </div>
                <div>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/mobile.png"
                      alt="Gayatri International School"
                      className="mobile-ftr"
                    />
                  </LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright">
        ©️ Copyright {currentYear} Gayatri International School. All Right
        Reserved | Created By{" "}
        <a href="https://www.entab.in" target="_blank">
          Entab Infotech : CampusCare®️{" "}
        </a>
      </div>
    </>
  );
};

export default Footer;
